<template>
    <Toast :position="isMobile ? 'top-center' : 'top-right'" class="global-toast" />
    <router-view />

    <!-- 📌 Device Display Box -->
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

// 👉 Detect screen width
const isMobileScreen = ref(window.innerWidth < 768);
const updateSize = () => (isMobileScreen.value = window.innerWidth < 768);

// 👉 Detect actual mobile device (Android / iPhone)
const isRealMobileDevice = ref(false);

// 👉 Store user agent
const userAgent = ref('');

// 👉 Final flag used by Toast
const isMobile = ref(false);

const detectDevice = () => {
    const ua = navigator.userAgent;
    userAgent.value = ua;

    isRealMobileDevice.value = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
};

// const userStore = useUserStore();

// async function initAuth() {
//     // Skip if already initialized
//     if (userStore.authInitialized) return;

//     try {
//         const res = await fetch('https://jokkkjuvydarwembwfuj.supabase.co/functions/v1/get-auth-cookies', {
//             method: 'GET',
//             credentials: 'include' // send cookies
//         });

//         if (res.ok) {
//             const { access_token } = await res.json();
//             if (access_token) {
//                 await supabase.auth.setSession({ access_token });
//                 userStore.setAuth(access_token);
//             }
//         }
//     } catch (err) {
//         console.error('Failed to init auth from cookies', err);
//     }
// }

onMounted(() => {
    detectDevice();
    // initAuth();

    isMobile.value = isMobileScreen.value || isRealMobileDevice.value;

    window.addEventListener('resize', updateSize);
});

onUnmounted(() => window.removeEventListener('resize', updateSize));
</script>

<style>
.device-info-box {
    position: fixed;
    bottom: 20px;
    left: 20px;
    background: #fff;
    padding: 12px 15px;
    border-radius: 10px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    font-size: 13px;
    z-index: 9999;
    width: 250px;
}

.device-info-box .ua {
    font-size: 11px;
    white-space: normal;
    word-wrap: break-word;
}

/* Toast CSS */
.p-toast {
    z-index: 9999;
}

.global-toast .p-toast-message {
    width: 350px;
    font-size: 14px;
}

@media (max-width: 768px) {
    .global-toast .p-toast-message {
        width: 85vw;
        font-size: 13px;
    }
}
</style>
